<template>
  <div class="public-customer">
    <el-form @submit.native.prevent :inline="true">
      <el-form-item>
        <el-input class="search-input" v-model.trim="customerName" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="customerLevel" placeholder="请选择客户级别" clearable>
          <el-option v-for="item in custLevelOptions" :key="item.id" :label="item.description" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="operation-area">
      <span class="select-num">已选中 {{ selectedList.length }} 项</span>
      <auth-button icon="el-icon-share" code="GHFP" type="primary" plain size="mini" @click="allotUser">分配</auth-button>
      <!-- <auth-button icon="el-icon-download" code="GHDC" type="primary" plain size="mini" @click="exportList">导出选中</auth-button> -->
      <auth-button icon="el-icon-delete" code="GHSC" type="danger" plain size="mini" @click="deleCustomer">删除</auth-button>
      <div class="right-btn">
        <auth-button icon="el-icon-download" code="GHXZMB" plain @click="downloadList">下载模板</auth-button>
        <el-upload class="uploader" action="#" :http-request="importExcel" :before-upload="beforeUploadExcel" :show-file-list="false" accept=".xlsx, .xls">
          <auth-button icon="el-icon-upload2" code="GHKHDR" plain>批量导入</auth-button>
        </el-upload>
      </div>
    </div>
    <div class="list-table">
      <new-table ref="pubCustRef" :data="tableData" :columns="columns" :pages="pages" firstType="selection" @selection-change="selectChange"></new-table>
    </div>
    <el-dialog :visible.sync="selectUserVisible" title="选择人员" width="800px">
      <role-user @selectionChange="selectUser" :isMultiple="false"></role-user>
    </el-dialog>
  </div>
</template>

<script>
import { CustomerApis, DictionaryApis } from "@/apis/index";
import { DictionaryKey } from "@/utils/enum";
import NewTable from "@/components/new-table.vue";
import RoleUser from "@/components/role-user";

export default {
  name: "public-customer",
  data() {
    return {
      customerName: "",
      customerLevel: "",
      timeRange: [],
      custLevelOptions: [],
      tableData: [],
      selectedList: [],
      selectedUser: [],
      columns: [
        {
          label: "客户名称",
          render: (h, { row }) => (
            <span class="text-btn" onClick={() => this.viewDetail(row)}>
              {row.customerName}
            </span>
          ),
        },
        { label: "客户来源", prop: "formSourceName" },
        { label: "联系人", prop: "linkMan" },
        { label: "联系人电话", prop: "linkPhone" },
        { label: "网址", prop: "url" },
        { label: "行业", prop: "industryClassName" },
        { label: "客户级别", prop: "customerLevelName" },
        { label: "地址", prop: "fullAddress" },
        { label: "时间", prop: "createTime", width: "140" },
        { label: "跟进状态", prop: "followupStateName" },
        {
          label: "操作",
          render: (h, { row }) => {
            return (
              <el-button type="text" onClick={() => this.viewDetail(row)}>
                详情
              </el-button>
            );
          },
        },
      ],
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change": this.sizeChange,
        },
      },
      selectUserVisible: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      DictionaryApis.getDictValueByKey(DictionaryKey.CustLevel).then((res) => {
        this.custLevelOptions = res;
      });
      this.getPublicCustList();
    },
    getPublicCustList() {
      const parmas = {
        customerName: this.customerName,
        customerLevel: this.customerLevel,
        startTime: this.timeRange && this.timeRange[0],
        endTime: this.timeRange && this.timeRange[1],
        pageIndex: this.pages.props["current-page"],
        pageSize: this.pages.props["page-size"],
      };
      CustomerApis.getPublicCustomer(parmas).then((res) => {
        res.data.forEach((i) => {
          i.fullAddress = (i.province || "") + (i.city || "") + (i.district || "") + (i.address || "");
          const chief = i.linkUserList.find((i) => i.isChief) || i.linkUserList[0];
          i.linkMan = chief ? chief.linkName : "";
          i.linkPhone = chief ? chief.linkPhone : "";
        });
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    onSearch() {
      this.currentChange(1);
    },
    reset() {
      this.customerName = "";
      this.customerLevel = "";
      this.timeRange = [];
      this.currentChange(1);
    },
    selectChange(list) {
      this.selectedList = list;
    },

    sizeChange(size) {
      this.pages.props["page-size"] = size;
      this.currentChange(1);
    },
    currentChange(p) {
      this.pages.props["current-page"] = p;
      this.getPublicCustList();
    },
    viewDetail(row) {
      this.$router.push(`/customer-detail?id=${row.id}&editable=false`);
    },
    allotUser() {
      if (!this.selectedList.length) return this.$message.warning("请先选择客户");
      this.selectUserVisible = true;
    },
    exportList() {
      if (!this.selectedList.length) return this.$message.warning("请先选择客户");
    },
    downloadList() {
      window.open(`${this.$ossUrl}/crm/import/公海客户导入模板.xls`);
    },
    //批量导入
    importExcel(param) {
      const formData = new FormData();
      formData.append("file", param.file);
      CustomerApis.importCrmCustomer(formData).then((res) => {
        let timer = setTimeout(() => {
          CustomerApis.checkImportCustomer().then((res) => {
            if (res) {
              this.getPublicCustList();
              clearTimeout(timer);
            }
          });
        }, 1000);
      });
    },
    beforeUploadExcel(file) {
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      if (!extension && !extension2) {
        return this.$message.error("上传模板只能是 xls、xlsx格式!");
      }
      const isLt2M = file.size / 1024 / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.warning("文件大小不能超过50M!");
        return false;
      }
    },
    deleCustomer() {
      if (!this.selectedList.length) return this.$message.warning("请先选择客户");
      this.$confirm("确定要删除选中的客户吗?", "注意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const idList = { listId: this.selectedList.map((i) => i.id) };
          CustomerApis.delePublicCustomer(idList).then((res) => {
            this.$refs.pubCustRef.clearSelection();
            this.$message.success("删除成功");
            this.onSearch();
          });
        })
        .catch(() => {});
    },
    selectUser(user) {
      this.$confirm(`确定要将选中的客户分配给“${user.realName || ""}”吗？`, "注意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.selectUserVisible = false;
          const parmas = {
            chargeId: user.id,
            chargeName: user.realName || "",
            customerIdList: this.selectedList.map((i) => i.id),
          };
          CustomerApis.batchDistributeCustomer(parmas).then((res) => {
            this.$message.success("分配成功");
            this.getPublicCustList();
          });
        })
        .catch(() => {});
    },
  },
  components: { NewTable, RoleUser },
};
</script>

<style scoped lang="scss">
.public-customer {
  flex-direction: column;
}
.operation-area {
  padding-bottom: 15px;
  .select-num {
    display: inline-block;
    padding-right: 20px;
  }
  .right-btn {
    float: right;
  }
  .uploader {
    display: inline-block;
    margin-left: 10px;
  }
}
::v-deep {
  .text-btn {
    color: #3d9cfc;
    cursor: pointer;
  }
}
</style>
